import { useNotificationsStore } from '@/stores/notifications-store';
import { getDeviceInfo } from '@/plugins/device';
import { storeToRefs } from 'pinia';
import router from '@/router';
import { useToast } from './useToast';

export const useNotifications = () => {
  const handleRegisterDevice = async (token: string) => {
    const { registerDevice } = useNotificationsStore();

    const device = await getDeviceInfo();
    try {
      const form = {
        tokenDevice: token,
        name: device.name ?? null,
        model: device.model,
        platform: device.platform,
        operatingSystem: device.operatingSystem,
        osVersion: device.osVersion,
        iOSVersion: device.iOSVersion ?? null,
        androidSDKVersion: device.androidSDKVersion ?? null,
        manufacturer: device.manufacturer,
        isVirtual: device.isVirtual,
        webViewVersion: device.webViewVersion,
      };
      await registerDevice(form);
    } catch (error) {
      const errorMsg = error?.toString() ?? 'Unknown error!';
      console.error(errorMsg);
    }
  };

  const handleGetNotifications = async (page: number = 1) => {
    const { getNotifications } = useNotificationsStore();
    const { notificationsInPage } = storeToRefs(useNotificationsStore());
    const { showToast } = useToast();

    try {
      if (page === 1) {
        notificationsInPage.value = [];
      }

      const data = await getNotifications(page);

      if (data) {
        const newNotifications = JSON.parse(JSON.stringify(data));

        notificationsInPage.value = notificationsInPage.value.concat(newNotifications);
      }
    } catch (error) {
      await showToast(error instanceof Error ? error.message : 'Unknown error', 'error');
    }
  };

  const handleMarkAsRead = async (notificationId: string) => {
    const { markAsRead } = useNotificationsStore();

    try {
      markAsRead(notificationId);
    } catch (error) {
      console.error(error);
    }
  };

  const updateNotificationStatus = (notificationId: string) => {
    const { notificationsInPage, isRead } = storeToRefs(useNotificationsStore());
    const notification = notificationsInPage.value.find(
      (notification) => notification.id === notificationId,
    );

    if (notification && !isRead.value && !notification.isRead) {
      notificationsInPage.value = notificationsInPage.value.filter(
        (notification) => notification.id !== notificationId,
      );
    } else if (notification && isRead.value) {
      notification.isRead = true;
    }
  };

  const handleClickNotification = (notificationId: string, type: string, actionId: string) => {
    handleMarkAsRead(notificationId);
    updateNotificationStatus(notificationId);

    if (type === 'reservations') {
      router.replace({
        name: 'Bookings',
        params: { bookingId: actionId },
        query: { notificationId: notificationId },
      });
    }
    if (type === 'invoices') {
      router.replace({
        name: 'InvoiceDetail',
        params: { invoiceId: actionId },
      });
    }
  };

  return {
    handleRegisterDevice,
    handleGetNotifications,
    handleMarkAsRead,
    handleClickNotification,
  };
};
